<template>
  <a-modal title="Penalize Shifts" :visible="visible" :destroy-on-close="true" @cancel="closeModal">
    <a-form-model
      layout="horizontal"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-model-item :colon="false" label-align="left" label="Reason" prop="reason">
        <a-textarea v-model="form.reason" placeholder="Enter Reason" />
      </a-form-model-item>

      <a-form-model-item :colon="false" label="Shifts" label-align="left" prop="amount">
        <a-input-number v-model="form.amount" :min="0" placeholder="Enter amount" />
      </a-form-model-item>
    </a-form-model>

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Cancel</a-button>
        <a-button @click="handleSubmit" type="primary" :loading="loading">Penalize</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { deepCopy } from '@/utils/deep-copy'
import { Button, FormModel, Input, InputNumber, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

const initialForm = {
  reason: undefined,
  amount: 0
}

const initialRules = {
  reason: [
    {
      required: true,
      message: 'Reason date can not be empty',
      trigger: 'change'
    }
  ],
  amount: [
    {
      required: true,
      message: 'Amount can not be empty',
      trigger: 'change',
      type: 'number'
    },
    {
      min: 1,
      message: 'Amount can not be empty',
      trigger: 'change',
      type: 'number'
    }
  ]
}

export default {
  components: {
    'a-modal': Modal,
    'a-form-model-item': FormModel.Item,
    'a-form-model': FormModel,
    'a-input-number': InputNumber,
    'a-button': Button,
    'a-textarea': Input.TextArea
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: { ...initialForm },
      rules: { ...initialRules },

      loading: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  methods: {
    ...profileActions(['postShiftPenalty']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      this.$emit('update:visible', false)
      this.form = deepCopy(initialForm)
    },

    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          this.loading = true

          const payload = { associate_id: this.associate.id, ...this.form }

          await this.postShiftPenalty(payload)

          this.showNotification('success', 'Success', 'Shift penalty has been create successfully')

          this.closeModal()
          this.$emit('add')
        } catch (error) {
          this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.ant-row {
  display: flex;
  margin: 0 !important;
}

.ant-form {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
}

::v-deep .ant-input-number {
  width: 100%;
}
</style>
